import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const cadenlaneSizes = [
  // Baby Age Sizes (birth to 2 years)
  'Newborn',
  'NB',
  '0-3 months',
  '3-6 months',
  '6-9 months',
  '6-12 months',
  '12-18 months',
  '18-24 months',

  // Toddler Sizes (T-sizes)
  '2T',
  '3T',
  '4T',
  '5T',

  // Kids Clothing Sizes (numeric)
  '5/6',
  '7/8',
  '9/10',

  // Standard Clothing Sizes (XS-3XL)
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '2XL',
  '3XL',

  // Women's/Adult Sizes with measurements
  'S (6-8)',
  'M (10-12)',
  'L (14-16)',
  'XL (18-20)',

  // Blanket Sizes
  'Baby Blanket (30" x 40")',
  'Kids Blanket (50" x 60")',
  'Throw Blanket (60"x 80")',

  // Product/Material Options
  'Swatch',
  'Roll',

  // Generic Size Categories
  'Small',
  'Large',
];

export const cadenlaneShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: cadenlaneSizes }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '05c4bf2689534ef6af2b834954d077c7',
      [BuilderSections.FooterContent]: 'eef919e199964a1aa125951816f58a19',
    },
  },
};
